import { render, staticRenderFns } from "./NewShipper.vue?vue&type=template&id=7d6a246f&scoped=true"
import script from "./NewShipper.vue?vue&type=script&lang=js"
export * from "./NewShipper.vue?vue&type=script&lang=js"
import style0 from "./NewShipper.vue?vue&type=style&index=0&id=7d6a246f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6a246f",
  null
  
)

export default component.exports